import { useCallback } from "react";

const CLASS_IFRAME_BODY_SCROLL = "cxSurveyPreviewMode";

const useScrollOverflow = () => {
  const scrollOverflowOn = useCallback(() => {
    const bodyTarget = document.querySelector("body");
    if (bodyTarget) {
      bodyTarget.classList?.add(CLASS_IFRAME_BODY_SCROLL);
    }
  }, []);

  const scrollOverflowOff = useCallback(() => {
    const bodyCleanup = document.querySelector("body");
    if (bodyCleanup) {
      bodyCleanup.classList?.remove(CLASS_IFRAME_BODY_SCROLL);
    }
  }, []);

  return {
    scrollOverflowOn,
    scrollOverflowOff,
  };
};

export default useScrollOverflow;
